<template>
  <div :class="{fullscreen}" v-click-outside="onClickOutside">
    <form class="form search" id="searchForm" :action="form_action" role="form" ref="searchForm" method="get">
      <div class="input-group">
        <div class="input-group-prepend" v-if="fullscreen">
          <button class="btn btn-tertiary" type="button" @click="closeFullscreen()"><i class="fas fa-arrow-left"></i></button>
        </div>

        <input class="form-control" type="text" id="searchParam" name="searchparam" autocomplete="off" ref="searchParam"
               v-model="preSearchValue"
               @focus="onFocusSearchParam"
               :placeholder="$t('placeholder')"
        >

        <div class="input-group-append">
          <button id="searchSubmit" :title="button_title" class="btn btn-tertiary" type="button" ref="searchSubmit"
                @focus="onFocusSearchParam"
          >
            <i v-if="spinner" class="fas fa-spinner fa-pulse"></i>
            <i v-else class="fas fa-search"></i>
          </button>
        </div>
      </div>
    </form>

      <div v-if="this.isMobile" class="mobile-result" :style="{top: this.top}">
        <search-results-mobile
            :query="preSearchValue"
            :suggestions="found_suggestions"
            :categories="found_categories"
            :projects="found_projects"
            :products="found_products"
            :no_results="no_results"
            v-show="showSearchResults && found_count > 0"
            v-on:submitForm="submitForm"
        />
      </div>

      <search-results-table-desktop
          :query="preSearchValue"
          :suggestions="found_suggestions"
          :categories="found_categories"
          :projects="found_projects"
          :products="found_products"
          :no_results="no_results"
          v-show="(showSearchResults && found_count > 0) || no_results"
          v-on:submitForm="submitForm"
          v-if="!this.isMobile"
          ref="searchResultsTableDesktop"
      />
  </div>
</template>
<script>

import searchResultsTableDesktop from "./searchResultsTableDesktop";
import searchResultsMobile from "./searchResultsMobile";
import backgroundDark from "./class/BackgroundDark.js";
import ClickOutside from 'vue-click-outside'

let waitNextChar = undefined,
    scroll_ticking = false;

export default {
  name: "findologic-suggester",
  props: ['button_title', 'form_action', 'search_param'],
  components: {
    searchResultsTableDesktop,
    searchResultsMobile,
  },
  created() {
    this.preSearchValue = this.search_param;
  },
  data() {
    return {
      showSearchResults: false,
      preSearchValue: '',
      isNoCallSuggest: false,
      fullscreen: false,
      top: '45px',
      found_count: 0,
      found_suggestions: [],
      found_categories: [],
      found_projects: [],
      found_products: [],
      no_results: false,
      spinner: false,
      isMobile: false,
      focusId: null,
    }
  },
  watch: {
    //Wartet auf veränderungen
    preSearchValue(value) {
      this.no_results = false

      if (waitNextChar !== undefined) {
        clearTimeout(waitNextChar);
        waitNextChar = undefined;
      }

      if (value === "") {
        this.clear();
        return;
      }

      waitNextChar = setTimeout(() => this.preSearch(), 300);
    },
  },

  mounted () {
    window.addEventListener('scroll', this.onScroll)
    this.onMobile(() => this.isMobile = false)
  },

  beforeDestroy () {
    window.addEventListener('scroll', this.onScroll)
  },

  directives: {
    ClickOutside
  },

  methods: {
    onFocusSearchParam() {
      if (!this.isMobile) {
        window.scrollTo({top: 0});
      }

      // Workaround: box closed immediately if user is logged in
      setTimeout(function () {
        this.showSearchResults = true;
      }.bind(this), 100)

      this.no_results = false;
      this.focusId = null;
      backgroundDark.show();
      this.onMobile(() => this.fullscreen = true);
      window.addEventListener('keydown', this.handleKeyDown);
      document.querySelector(".main-row").style.overflow = 'hidden';
    },

    closeFullscreen() {
      this.fullscreen = false;
      this.showSearchResults = false;
      this.no_results = false;
      backgroundDark.hide();
      window.removeEventListener('keydown', this.handleKeyDown);
      document.querySelector(".main-row").style.overflow = '';
    },

    onClickOutside() {
      if (!this.isMobile && this.showSearchResults) {
        this.showSearchResults = false;
        this.no_results = false;
        backgroundDark.hide();
        window.removeEventListener('keydown', this.handleKeyDown);
        document.querySelector(".main-row").style.overflow = '';
      }
    },

    onScroll() {
      if (this.fullscreen === false) {
        return;
      }
      let lastKnownScrollPosition = window.scrollY;
      if (!scroll_ticking) {
        window.requestAnimationFrame(() => {
          this.top = (45 - lastKnownScrollPosition) + 'px'
          scroll_ticking = false;
        });

        scroll_ticking = true;
      }
    },

    handleKeyDown(e) {
      // Escape
      if (e.keyCode === 27) {
        this.$refs.searchParam.blur()
        this.onClickOutside()
        return
      }

      // Scroll up = 38; Scroll down = 40
      // Scroll left = 37; Scroll right = 39
      if (e.keyCode === 38 || e.keyCode === 40 || (this.focusId !== null && (e.keyCode === 37 || e.keyCode === 39))) {
        e.preventDefault();

        // result elements
        let resElems = this.$refs.searchResultsTableDesktop.$refs.resElem;

        if (this.focusId === null) {
          this.focusId = 0;
        } else  {
          let refType = null;
          let refCount = resElems.length;

          if (resElems[this.focusId].classList.contains('product')) {
            refType = 'product';
          } else if (resElems[this.focusId].classList.contains('category')) {
            refType = 'categpry';
          }

          // Scroll down = 40;
          if (e.keyCode === 40) {
            if (refType === 'product') {
              this.focusId = this.focusId + 4
            } else {
              this.focusId++
            }

            if (this.focusId >= refCount) {
              this.focusId = refCount - 1
            }

          // Scroll right = 39;
          } else if (e.keyCode === 39) {
            if (refCount > this.focusId + 1) {
              this.focusId++
            }

          // Scroll up = 38
          } else if (e.keyCode === 38) {

            if (this.focusId > 0) {
              if (refType === 'product') {
                this.focusId = this.focusId - 4
              } else {
                this.focusId--
              }

              if (this.focusId < 0) {
                this.focusId = null;
                this.$refs.searchParam.focus()
                return
              }

            } else {
              this.focusId = null
              this.$refs.searchParam.focus()
              return
            }

          // Scroll left = 37;
          } else if (e.keyCode === 37) {
            // Scroll up = 38; Scroll left = 37;
            if (this.focusId > 0) {
              this.focusId--
            } else {
              this.focusId = null
              this.$refs.searchParam.focus()
              return
            }

          }
        }

        resElems[this.focusId].focus()
      }
    },

    onMobile(fn) {
      if (util.handleResize() !== 'large') {
        fn();
        this.isMobile = true;
      }
    },

    clear() {
      this.found_count = 0
      this.found_suggestions = []
      this.found_categories = []
      this.found_projects = []
      this.found_products = []
      this.no_results = false;
      this.spinner = false;
    },

    //Offizelle suche starten
    submitForm({query}) {
      this.isNoCallSuggest = true;
      this.preSearchValue = query;

      this.$nextTick(() => this.$refs.searchForm.submit());
    },

    //API Anfrage nach dem Paramerter
    async preSearch() {
      if (this.isNoCallSuggest) {
        return
      }

      try {
        const form = document.getElementById('searchForm');
        let formData = new FormData(form);
        formData.set('cl', 'smartsuggest')
        formData.set('isFullscreen', this.fullscreen)
        this.no_results = false
        this.spinner = true

        //Anfrage
        const {data} = await this.$http.post(
            '/',
            formData
        );

        //Wenn in zwischen es wieder gelöscht wurde
        if (this.preSearchValue === "") {
          this.clear();
          return;
        }

        //Daten einfügen
        this.found_count = data.count;
        this.found_suggestions = data.suggestions;
        this.found_categories = data.categories;
        this.found_projects = data.projects;
        this.found_products = data.products;

        if (data) {
          this.spinner = false;
        }

        if (data.count === 0) {
          this.no_results = true;
        }

      } catch (err) {
        this.clear();
      }
    },
  }
}

const util = {
  defaultBreakpoints: {
    small: 744,
    medium: 1060,
    large: Infinity
  },
  handleResize () {
    const clientWidth = window.innerWidth
    if (clientWidth < util.defaultBreakpoints.small) {
      return 'small'
    } else if (clientWidth < util.defaultBreakpoints.medium) {
      return 'medium'
    } else if (clientWidth <= util.defaultBreakpoints.large) {
      return 'large'
    }
  }
}
</script>

<style>

.fullscreen {
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  background-color: white;
  z-index: 1000;
}

.mobile-result {
  position: fixed;
  max-width: 100%;
}

.mobile-result .product-info {
  padding-left: 0;
  font-size: 0.9rem;
}

#searchForm .input-group {
  z-index: 10;
}

</style>
